import { render } from "./page8.vue?vue&type=template&id=0dd0d30e&scoped=true"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"

import "./page8.vue?vue&type=style&index=0&id=0dd0d30e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd0d30e"]])

export default __exports__